/*global google*/

import Typography from '@material-ui/core/Typography';
import React, { Component } from "react";
import {
    withGoogleMap,
    withScriptjs,
    GoogleMap,
    DirectionsRenderer
} from "react-google-maps";


class Maproute extends Component{

  constructor(props) {
    super(props);
    this.state = {
      directions:null,
      geosaida:null, geovolta:null,
      distancia: null, tempo:null,distancia2: null,
};
  }
    
  

  
    




componentDidMount() {

 
  
  console.log('dentro do map destino', this.props.destino);
    //const destino;
    const directionsService = new google.maps.DirectionsService();
    
  const matrix = new google.maps.DistanceMatrixService();
  const geocoderdestino = new google.maps.Geocoder();
  const geocodersaida = new google.maps.Geocoder();
  const geocoderparadasvolta = new google.maps.Geocoder();
   // const origin = { lat: -29.7001524, lng:  -53.824063 };
    //const origin1 = ('ChIJFcinNOe1A5UR7Ccn-b35s4I');
   var geodestino=""
   var geosaida=""
    var saida='';
    var dest='';
    var listapida= this.props.listaparadasida;
    var litsapvolta = this.props.listaparadasvolta;
    var listaida=[];
    var listavolta=[];
    //const destination1 = { lat: -29.7215493, lng:  -53.71837069999999 };
    

    //**********************************geo destino */
    
 geocoderdestino.geocode({ placeId: this.props.destino.place_id }, (results, status) => {
      if (status === "OK") {
        var latitude = results[0].geometry.location.lat();
        var longitude = results[0].geometry.location.lng();
        geodestino=results[0].formatted_address;
        this.setState({directionsdestino:geodestino})
       dest={ lat: results[0].geometry.location.lat(), lng:  results[0].geometry.location.lng() };
       this.setState({geovolta:dest})
       console.log('resultado geocode',results);
       gerparadavolta();
       
      } else {
        console.error("Geocode was not successful for the following reason: " + status);
      }
    })

   

 //*************************gerar geocode paradas volta 
 
    function gerparadavolta (){

      if((litsapvolta.length>0)&&(litsapvolta[0]!='')){
 
      for (let index = 0; index < litsapvolta.length; index++) {
      console.log("entrou no for", litsapvolta);
      geocoderparadasvolta.geocode({ placeId: litsapvolta[index].value.place_id }, (results, status) => {
        if (status === "OK") {
         // var latitude = results[0].geometry.location.lat();
         //var longitude = results[0].geometry.location.lng();
          //geodestino=results[0].formatted_address;
        // this.setState({listapvolta: this.state.listapvolta.concat([geodestino])})
         //dest={ lat: results[0].geometry.location.lat(), lng:  results[0].geometry.location.lng() };
         listavolta.push({location: new google.maps.LatLng(results[0].geometry.location.lat(),results[0].geometry.location.lng())})
        
         //this.setState({listgeovolta:  (currentArray => [...currentArray, dest])})
         //this.setState({listgeovolta: this.state.listgeovolta.push([dest])})
         console.log('resultado geocode aquiiii',dest);
         console.log('resultado geocode',results);
           
        } else {
          alert("Geocode was not successful for the following reason: " + status);
        }
      })
      
    }
  }
  gerasaida();
}


 //*************************gerar geocode saida  */
    
 const gerasaida=()=>(
 geocodersaida.geocode({ placeId: this.props.saida.place_id }, (results, status) => {
      if (status === "OK") {
        //resultsMap.setCenter(results[0].geometry.location);
       var latitude = results[0].geometry.location.lat();
        var longitude = results[0].geometry.location.lng();
        geosaida=results[0].formatted_address;
        this.setState({directionssaida:geosaida})
       saida={ lat: results[0].geometry.location.lat(), lng:  results[0].geometry.location.lng() };
      // this.setState({geosaida:{lat: results[0].geometry.location.lat(), lng:  results[0].geometry.location.lng() })
       console.log('resultado geocode',results);
      
       geramapa();
        //geramaparetorno();
      } else {
        console.error("Geocode was not successful for the following reason: " + status);
      }
    })
 )

    const geramapa=()=>(
     // console.log("Geocode was not successful for the following reason: " , saida),
      //console.log("Geocode was not successful for the following reason: " ,dest),
      directionsService.route(
        //var des={lat:latitude, lng:longitude},
         {
            
              origin: saida,
              destination: dest,
              travelMode: google.maps.TravelMode.DRIVING,
           waypoints: listavolta,
                 /*[ {
                      location: new google.maps.LatLng(6.4698,  3.5852)
                  },
                  {
                      location: new google.maps.LatLng(6.6018,3.3515)
                  }
              ]*/
          },
          (result, status) => {
              if (status === google.maps.DirectionsStatus.OK) {
                  console.log('aqui',result.routes[0].legs[0].distance.value);
                  var dis2 = result.routes[0].legs[0].distance.value/1000;
                  var dis = result.routes[0].legs[0].distance.text;
                  var tempo=result.routes[0].legs[0].duration.text;
                  //
                  this.setState({
                    distancia: dis
                    //console.log(`error fetching directions ` );
                });
                this.setState({
                  distancia2: dis2*2
                  //console.log(`error fetching directions ` );
              });
                this.setState({
                  tempo: tempo
                  //console.log(`error fetching directions ` );
              });
                  //res=result;
                  this.setState({
                      directions: result
                      //console.log(`error fetching directions ` );
                  });
                  this.props.setakm(dis2*2);
              } else {
                  console.error(`error fetching directions ${result}`);
              }
          }
      )
      
  )


 
    
}





render() {
  //this.props.setadestinogeo(this.setState.geosaida);
  //this.props.setasaidageo(this.setState.geovolta);
 
  //this.props.setalistaidageo(this.state.listageoida);
  //this.props.setalistavoltageo(this.state.listgeovolta);
  //this.props.setalistaidageo(this.state.listapida);
  //const {retorno}=this.state.directions;
  //console.log()
    const GoogleMapExample = withGoogleMap(props => (
        <GoogleMap
            defaultCenter={{ lat: -29.7215493, lng:  -53.71837069999999 }}
            defaultZoom={1}
        >
          {console.log("putssss" , this.state.directions)}
            <DirectionsRenderer
                directions={this.state.directions}
            />
        </GoogleMap>

          

        
    )
    
    
    );

  

    

    return (
      
      
        <div>
          
         
          <Typography variant="body2" color="textSecondary" component="p">
               Local de Saida: {this.state.directionssaida}
              
             </Typography>
             <Typography variant="body2" color="textSecondary" component="p">
               Local de Destino: {this.state.directionsdestino}
              
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               Kilometragem prevista: {this.state.distancia}
               <br></br>
               Tempo previsto de deslocamento: {this.state.tempo}
               
             </Typography>
           
             <GoogleMapExample
            containerElement={<div style={{ height: `400px`, width: "365px" }} />}
            mapElement={<div style={{ height: `100%` }} />}
        />





        </div>
        


       );
    }
}

export default Maproute;

/*
<div>
            <GoogleMapExample
                containerElement={<div style={{ height: `400px`, width: "365px" }} />}
                mapElement={<div style={{ height: `100%` }} />}
            />
        </div>
*/